<template>
	<div class="text-justify">
		<div class="row">
			<div class="col-lg-12">
				<lead-profile-tab-class-table></lead-profile-tab-class-table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "LeadTabClass",
	data() {
		return {
			class: {},
		};
	},
};
</script>

<style scoped>
.ml-20 {
	margin-left: 20px; /* You can adjust the margin value as needed */
}
.mr-20 {
	margin-right: 20px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 20px;
}
</style>
